module.exports = __webpack_public_path__ + "static/ray-3bb065552fae99c638146b15151dda23.gif";